// src/pages/Dashboard/components/CasePanel/DocumentsSection/DocumentItem.js

import React from 'react';

/**
 * Item individual de documento sugerido
 * @param {object} documento - Objeto do documento
 * @param {function} onGenerate - Callback para gerar documento
 */
const DocumentItem = ({ documento, onGenerate }) => {
  // ✅ MODIFICADO: Suporta tanto 'justificacao' (documentos processados) quanto 'descricao' (TIPOS_DOCUMENTO)
  const descricao = documento.descricao || documento.justificacao || '';
  
  return (
    <div className="documento-item-dashboard">
      <div className="documento-info">
        <strong>{documento.titulo}</strong>
        {descricao && <small>{descricao}</small>}
      </div>
      <button 
        className="btn-gerar-dashboard"
        onClick={() => onGenerate(documento)}
      >
        Gerar
      </button>
    </div>
  );
};

export default DocumentItem;